import React from 'react';

const ShapeBubble = ({
  className = 'shape shape-2',
  desktopSrc = '/images/others/bubble-23.webp',
  desktopSrc2x = '/images/others/bubble-23@2x.webp',
  mobileSrc = '/images/others/bubble-23-mobile-small.webp',
  mobileSrc2x = '/images/others/bubble-23-mobile.webp',
  alt = 'Bubble',
  width,
  height,
}) => {
  return (
    <li className={className}>
      <picture>
        <source
          srcSet={`
            ${process.env.PUBLIC_URL + mobileSrc} 1x,
            ${process.env.PUBLIC_URL + mobileSrc2x} 2x
          `}
          media="(max-width: 768px)"
        />
        <source
          srcSet={`
            ${process.env.PUBLIC_URL + desktopSrc} 1x,
            ${process.env.PUBLIC_URL + desktopSrc2x} 2x
          `}
          media="(min-width: 769px)"
        />
        <img
          src={process.env.PUBLIC_URL + desktopSrc}
          alt={alt}
          width={width}
          height={height}
          loading="lazy"
        />
      </picture>
    </li>
  );
};

export default ShapeBubble;
